







































































































































































import { defineComponent, ref, computed, watch } from "@vue/composition-api";
import PlaceModel from "@/ts/models/placeClass";
import HeaderImage from "@c/molecules/media/HeaderImage.vue";
import { useActions, useGetters } from "vuex-composition-helpers";
import JoinButton from "@c/atoms/place/JoinButton.vue";
import CreatedBy from "@c/atoms/app/CreatedBy.vue";

export default defineComponent({
  name: "PlaceHeader",

  components: {
    HeaderImage,
    JoinButton,
    CreatedBy
  },

  props: {
    place: {
      type: Object as () => PlaceModel
    }
  },

  setup(props, { root }) {
    var morePlaceActions = ref([
      {
        title: root.$options.filters!.capitalize(root.$t("calendar")),
        action: () => {
          root.$router.push("/place/" + root.$route.params.id + "/calendar");
        },
        icon: "event"
      },
      {
        title: root.$options.filters!.capitalize(root.$t("notes")),
        action: () => {
          root.$router.push("/place/" + root.$route.params.id + "/notes");
        },
        icon: "description"
      },
      {
        title: root.$options.filters!.capitalize(root.$t("projects")),
        action: () => {
          root.$router.push("/place/" + root.$route.params.id + "/projects");
        },
        icon: "handyman"
      },
      {
        title: root.$options.filters!.capitalize(root.$t("events")),
        action: () => {
          root.$router.push("/place/" + root.$route.params.id + "/events");
        },
        icon: "star"
      }
    ]);

    var show_email = ref(false)

    return {
      morePlaceActions,
      show_email
    };
  }
});
